import React from 'react';
import ImageGallery from 'react-image-gallery';
import { Modal } from '../Modal';
export var ModalComponent = function (props) {
    var images = props.images, index = props.index, modalIsOpen = props.modalIsOpen, toggleModal = props.toggleModal;
    return (React.createElement(Modal, { onClose: toggleModal, open: modalIsOpen },
        React.createElement(ImageGallery, { items: images, showIndex: true, showPlayButton: false, showThumbnails: false, startIndex: index })));
};
